"use client";
import React from "react";
import { Link } from "react-router-dom";

import {
  Footer,
  FooterCopyright,
  FooterLink,
  FooterLinkGroup,
  FooterTitle,
} from "flowbite-react";
import {
  FaFacebook,
  FaInstagram,
  FaXTwitter,
  FaLinkedin,
  FaTiktok,
  FaYoutube,
} from "react-icons/fa6";

// No live Workman Naija accounts yet - shown but not clickable rather than
// linking to "#" or someone else's handle. Swap in real URLs once these exist.
const socialPlatforms = [
  { icon: FaFacebook, label: "Facebook" },
  { icon: FaInstagram, label: "Instagram" },
  { icon: FaXTwitter, label: "X (Twitter)" },
  { icon: FaLinkedin, label: "LinkedIn" },
  { icon: FaTiktok, label: "TikTok" },
  { icon: FaYoutube, label: "YouTube" },
];

// flowbite-react's FooterLinkProps doesn't type-check the extra `to` prop
// that Link needs when rendered via the polymorphic `as` prop.
const RouterFooterLink = FooterLink as unknown as React.ComponentType<
  React.ComponentProps<typeof FooterLink> & { as: typeof Link; to: string }
>;

const FooterComponent: React.FC = () => {
  return (
    <Footer bgDark>
      <div className="w-full">
        <div className="grid w-full grid-cols-2 gap-8 px-6 py-8 md:grid-cols-4">
          <div>
            <FooterTitle title="Company" />
            <FooterLinkGroup col>
              <RouterFooterLink as={Link} to="/about" href="/about">
                About Us
              </RouterFooterLink>
              <RouterFooterLink as={Link} to="/contact" href="/contact">
                Contact Us
              </RouterFooterLink>
            </FooterLinkGroup>
          </div>
          <div>
            <FooterTitle title="Help Center" />
            <FooterLinkGroup col>
              <RouterFooterLink as={Link} to="/search" href="/search">
                Find a Handyman
              </RouterFooterLink>
              <RouterFooterLink
                as={Link}
                to="/register-provider"
                href="/register-provider"
              >
                Become a Provider
              </RouterFooterLink>
              <RouterFooterLink as={Link} to="/how-it-works" href="/how-it-works">
                How It Works
              </RouterFooterLink>
              <RouterFooterLink as={Link} to="/faq" href="/faq">
                FAQ
              </RouterFooterLink>
              <RouterFooterLink as={Link} to="/contact" href="/contact">
                Support
              </RouterFooterLink>
            </FooterLinkGroup>
          </div>
          <div>
            <FooterTitle title="Legal" />
            <FooterLinkGroup col>
              <RouterFooterLink
                as={Link}
                to="/privacy-policy"
                href="/privacy-policy"
              >
                Privacy Policy
              </RouterFooterLink>
              <RouterFooterLink as={Link} to="/terms" href="/terms">
                Terms &amp; Conditions
              </RouterFooterLink>
            </FooterLinkGroup>
          </div>
          <div>
            <FooterTitle title="Get the App" />
            <FooterLinkGroup col>
              <RouterFooterLink as={Link} to="/download-app" href="/download-app">
                iOS &amp; Android
              </RouterFooterLink>
            </FooterLinkGroup>
          </div>
        </div>
        <div className="w-full bg-gray-700 px-4 py-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <FooterCopyright
              href="/"
              by="Workman Naija. All Rights Reserved."
              year={new Date().getFullYear()}
            />
            <div className="flex items-center gap-4">
              {socialPlatforms.map(({ icon: Icon, label }) => (
                <span
                  key={label}
                  className="text-gray-400 opacity-60 cursor-not-allowed"
                  aria-disabled="true"
                  title={`${label} - coming soon`}
                >
                  {Icon({ className: "h-5 w-5" })}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Footer>
  );
};

export default FooterComponent;
